/**
 * Armazon del backoffice: barra lateral fija y area de trabajo.
 *
 * Es tambien el guardia de `ADM-01`: sin sesion no se pinta nada del panel, ni
 * siquiera un instante. Que la comprobacion viva aca y no en cada pantalla es
 * lo que garantiza que una vista nueva quede protegida sin que nadie se acuerde
 * de protegerla.
 *
 * La proteccion de verdad esta en el servidor: la API no responde `/api/admin`
 * sin token. Esto solo evita mostrar un panel vacio y mandar a la persona donde
 * corresponde.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSesion } from '../../contexto/sesion-contexto';
import { rutas } from '../../utilidades/rutas';
import { NavegacionAdmin } from './NavegacionAdmin';

export function DisenoAdmin() {
  const { estado, administrador } = useSesion();
  const ubicacion = useLocation();

  // Con un token guardado pero todavia sin validar no se decide nada: mandar a
  // la vista de acceso aca haria parpadear el formulario en cada recarga.
  if (estado === 'comprobando') {
    return (
      <p className="cargando" role="status">
        Comprobando tu sesion…
      </p>
    );
  }

  if (estado === 'fuera' || administrador === null) {
    return <Navigate to={rutas.administracion.acceso()} replace />;
  }

  // Entro con la clave que le genero el sistema: la API no le responde nada del
  // panel hasta que la cambie, asi que se le pide aca en vez de dejarlo chocar
  // con errores en cada pantalla.
  if (administrador.debeCambiarClave && ubicacion.pathname !== rutas.administracion.clave()) {
    return <Navigate to={rutas.administracion.clave()} replace />;
  }

  return (
    <div className="admin">
      <NavegacionAdmin />
      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
}
